import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-locize-backend";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    saveMissing: true,
    lng: localStorage.getItem("lang") ? localStorage.getItem("lang") : "en",

    // have a common namespace used around the full app
    ns: ["namespace"],
    defaultNS: "namespace",

    debug: false,
    keySeparator: "### not used ###", // we use content as keys

    backend: {
      projectId: process.env.REACT_APP_LOCIZE_PROJECT,
      // apiKey: process.env.REACT_APP_LOCIZE_APIKEY,
      referenceLng: "en"
    },

    interpolation: {
      escapeValue: false // not needed for react!!
    },

    react: {
      useSuspense: false
    }
  });

export default i18n;
